import type { BffApiClient } from "@/app/api-client"
import type { InferRequestType } from "hono"

export type QueryInput = InferRequestType<
  BffApiClient["api"]["collections"][":id"]["activity"]["$get"]
>["param"]

export const getCollectionActivityQueryParams = (
  apiClient: BffApiClient,
  queryInput: QueryInput,
) => ({
  queryKey: ["collections", "activity", queryInput],
  queryFn: async ({ pageParam }: { pageParam?: string }) => {
    const response = await apiClient.api.collections[":id"].activity.$get({
      param: queryInput,
      query: { cursor: pageParam },
    })

    if (!response.ok) throw await response.json()

    return response.json()
  },
  initialPageParam: undefined,
  getNextPageParam: (lastPage: { cursor?: string }) => {
    return lastPage.cursor
  },
})

type QueryFn = ReturnType<typeof getCollectionActivityQueryParams>["queryFn"]

export type QueryResponse = Awaited<ReturnType<QueryFn>>
